<template>
  <div class="invoice-receipt-collection-record">
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <el-date-picker
          v-model="timeValue"
          type="daterange"
          :picker-options="pickerOptions2"
          size="small"
          unlink-panels
          @change="changeTimeValue"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
        <button-confirm @confirm="showMakeInvoiceDialogVisible" value="开收据" style="margin-left: 10px;" v-if="permissionCodes.indexOf('016005001') !== -1"/>
        <button-cancel @cancel="showMakeInvoiceByMainstayDialogVisible" value="按主体汇总开收据" style="margin-left: 10px;" v-if="permissionCodes.indexOf('016005001') !== -1" />
      </div>
      <input-search placeholder="费用项" @search="searchKey" />
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" :total="total" :pageNum="pageNum" :pageSize="pageSize" @reprintRow="reprintRow" @changePagination="changePagination" @changeSelection="changeSelection" :operationArr="operationArr" @invoiceRecordRow="toInvoiceRecordInfoPage"  />

    <!--    开收据-->
    <el-dialog title='收据信息' :visible.sync="makeInvoiceDialogVisible" width="800px">
      <form>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">开票对象：</span>
          </div>
          <el-select v-model="payerCode" filterable placeholder="请输入关键词查询" size="mini" style="width: 280px">
            <el-option v-for="item in payerList" :key="item._value" :label="item.payer" :value="item._value"></el-option>
          </el-select>
        </div>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">关联账单：</span>
          </div>
          <el-select v-model="payItemDetailCode" placeholder="请选择" size="small" style="width: 280px">
            <el-option v-for="item in payItemDetailList" :key="item.billNo" :label="item._label" :value="item.billNo"></el-option>
          </el-select>
        </div>
        <div class="form-line">
          <div class="textBox">
            <span class="line-text">收款人：</span>
          </div>
          <el-input v-model="payee" size="small" style="width: 280px" />
        </div>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">开票人：</span>
          </div>
          <el-input v-model="issuer" size="small" style="width: 280px" />
          <el-checkbox v-model="isDefault">默认开票人</el-checkbox>
        </div>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">开具类型：</span>
          </div>
          <el-select v-model="openType" placeholder="请选择" size="small" style="width: 280px">
            <el-option v-for="item in openTypeList" :key="item.key" :label="item.label" :value="item.key"></el-option>
          </el-select>
        </div>
      </form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="makeInvoiceDialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="showIssueReceiptDialog">确 认</el-button>
      </span>
    </el-dialog>

    <el-dialog title='收据预览' :visible.sync="issueReceiptDialogVisible" width="800px">
      <div class="receipt-box" :style="{'background-image': printingTemplateUrl}">
        <div class="printing-box" id="printReceipt" ref="print">
          <div class="printing-info1"></div>
          <div class="printing-info2">
            <div class="printing-info2-1">{{ receiptYear }}</div>
            <div class="printing-info2-2">{{ receiptMonth }}</div>
            <div class="printing-info2-3">{{ receiptDate }}</div>
          </div>
          <div class="printing-info3">{{ issueReceiptData.payer }}</div>
          <div class="printing-info4">{{ issueReceiptData.itemName }}</div>
          <div class="printing-info5">{{ issueReceiptData.amountInWords }}</div>
          <div class="printing-info6">
            <div v-for="item in issueReceiptData.amountUnit" class="printing-info6-item">{{ item }}</div>
          </div>
          <div class="printing-info7">{{ issueReceiptData.issuer }}</div>
          <div class="printing-info8">{{ issueReceiptData.payee || '' }}</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="issueReceiptDialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="printReceipt">打 印</el-button>
      </span>
    </el-dialog>

    <!--重新打印-->
    <el-dialog title='收据信息' :visible.sync="makeInvoiceReprintDialogVisible" width="800px">
      <form>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">开票对象：</span>
          </div>
          <el-input v-model="makeInvoiceReprintData.payer" size="small" style="width: 280px" disabled />
        </div>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">金额：</span>
          </div>
          <el-input v-model="makeInvoiceReprintData.money" size="small" style="width: 280px" disabled >
            <template slot="append">元</template>
          </el-input>
        </div>
        <div class="form-line">
          <div class="textBox">
            <span class="line-text">收款人：</span>
          </div>
          <el-input v-model="makeInvoiceReprintData.payee" size="small" style="width: 280px" />
        </div>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">开票人：</span>
          </div>
          <el-input v-model="makeInvoiceReprintData.issuer" size="small" style="width: 280px" />
        </div>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">开具类型：</span>
          </div>
          <el-select disabled v-model="makeInvoiceReprintData.openType" placeholder="请选择" size="small" style="width: 280px">
            <el-option v-for="item in openTypeList" :key="item.key" :label="item.label" :value="item.key"></el-option>
          </el-select>
        </div>
      </form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="makeInvoiceReprintDialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="showIssueReceiptReprintDialog">确 认</el-button>
      </span>
    </el-dialog>
    <el-dialog title='收据预览' :visible.sync="issueReceiptReprintDialogVisible" width="800px">
      <div class="receipt-box" :style="{'background-image': printingTemplateUrl}">
        <div class="printing-box" id="reprintReceipt" ref="print">
          <div class="printing-info1"></div>
          <div class="printing-info2">
            <div class="printing-info2-1">{{ receiptYear }}</div>
            <div class="printing-info2-2">{{ receiptMonth }}</div>
            <div class="printing-info2-3">{{ receiptDate }}</div>
          </div>
          <div class="printing-info3">{{ makeInvoiceReprintData.payer }}</div>
          <div class="printing-info4">{{ makeInvoiceReprintData.expenseItem }}</div>
          <div class="printing-info5">{{ makeInvoiceReprintData.amountInWords }}</div>
          <div class="printing-info6">
            <div v-for="item in makeInvoiceReprintData.amountUnit" class="printing-info6-item">{{ item }}</div>
          </div>
          <div class="printing-info7">{{ makeInvoiceReprintData.issuer }}</div>
          <div class="printing-info8">{{ makeInvoiceReprintData.payee || '' }}</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="issueReceiptReprintDialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="reprintReceipt">打 印</el-button>
      </span>
    </el-dialog>


    <!--按主体开收据-->
    <el-dialog title='收据信息' :visible.sync="makeInvoiceByMainstayDialogVisible" width="800px">
      <form>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">开票对象：</span>
          </div>
          <el-select v-model="enterpriseCodeByMainstay" filterable placeholder="请输入关键词查询" size="mini" style="width: 280px">
            <el-option v-for="item in enterpriseList" :key="item.enterpriseCode" :label="item.enterpriseName" :value="item.enterpriseCode"></el-option>
          </el-select>
        </div>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">收费时间：</span>
          </div>
          <el-date-picker v-model="chargingTime" size="small" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" value-format="yyyy-MM-dd"></el-date-picker>
        </div>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">收费项名称：</span>
          </div>
          <el-select v-model="expenseCodeByMainstay" placeholder="请选择" size="small" style="width: 280px">
            <el-option v-for="item in paymentItemList" :key="item.code" :label="item.name" :value="item.code"></el-option>
          </el-select>
        </div>
        <div class="form-line">
          <div class="textBox">
            <span class="line-text">汇总金额：</span>
          </div>
          <el-input v-model="totalAmount" size="small" style="width: 280px" disabled/>
        </div>
        <div class="form-line">
          <div class="textBox">
            <span class="line-text">收款人：</span>
          </div>
          <el-input v-model="payeeByMainstay" size="small" style="width: 280px" />
        </div>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">开票人：</span>
          </div>
          <el-input v-model="issuerByMainstay" size="small" style="width: 280px" />
          <el-checkbox v-model="isDefault">默认开票人</el-checkbox>
        </div>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">开具类型：</span>
          </div>
          <el-select v-model="openType" placeholder="请选择" size="small" style="width: 280px">
            <el-option v-for="item in openTypeList" :key="item.key" :label="item.label" :value="item.key"></el-option>
          </el-select>
        </div>
      </form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="makeInvoiceByMainstayDialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="showIssueReceiptByMainstayDialog">确 认</el-button>
      </span>
    </el-dialog>

    <el-dialog title='收据预览' :visible.sync="issueByMainstayReceiptDialogVisible" width="800px">
      <div class="receipt-box" :style="{'background-image': printingTemplateUrl}">
        <div class="printing-box" id="printReceiptByMainstay" ref="print">
          <div class="printing-info1"></div>
          <div class="printing-info2">
            <div class="printing-info2-1">{{ receiptYear }}</div>
            <div class="printing-info2-2">{{ receiptMonth }}</div>
            <div class="printing-info2-3">{{ receiptDate }}</div>
          </div>
          <div class="printing-info3">{{ issueByMainstayReceiptData.enterpriseName }}</div>
          <div class="printing-info4">{{ issueByMainstayReceiptData.expenseItem }}</div>
          <div class="printing-info5">{{ issueByMainstayReceiptData.amountInWords }}</div>
          <div class="printing-info6">
            <div v-for="item in issueByMainstayReceiptData.amountUnit" class="printing-info6-item">{{ item }}</div>
          </div>
          <div class="printing-info7">{{ issueByMainstayReceiptData.issuer }}</div>
          <div class="printing-info8">{{ issueByMainstayReceiptData.payee || '' }}</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="issueByMainstayReceiptDialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="printReceiptByMainstay">打 印</el-button>
      </span>
    </el-dialog>

    <!--    收据模板选择-->
    <el-dialog
      title="收据模板选择"
      :visible.sync="receiptTemplateDialogFormVisible"
      width="500px"
      class="contractDialogForm"
      v-loading="downloadNoticeLoading"
      element-loading-text="通知单生成中，请耐心等待"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)">
      <div>
        <div v-for="item in receiptTemplateDialogList" class="contractDialogLine" :key="item.templateName">
          <div>{{ item.templateName }}</div>
          <div class="operationBox">
            <span style="margin-right: 20px;" @click="previewContract(item.path, item.fileName, item.code)">预览</span>
            <span @click="downloadContract(item.path, item.fileName, item.code)">下载</span>
          </div>
        </div>
        <div v-if="receiptTemplateDialogList.length === 0" style="text-align: center;line-height: 100px;">暂无收据模板</div>
      </div>
    </el-dialog>
    <el-dialog
      title="收据模板选择"
      :visible.sync="receiptTemplateDialogFormVisible2"
      width="500px"
      class="contractDialogForm"
      v-loading="downloadNoticeLoading"
      element-loading-text="通知单生成中，请耐心等待"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)">
      <div>
        <div v-for="item in receiptTemplateDialogList" class="contractDialogLine" :key="item.templateName">
          <div>{{ item.templateName }}</div>
          <div class="operationBox">
            <span style="margin-right: 20px;" @click="previewContract2(item.path, item.fileName, item.code)">预览</span>
            <span @click="downloadContract2(item.path, item.fileName, item.code)">下载</span>
          </div>
        </div>
        <div v-if="receiptTemplateDialogList.length === 0" style="text-align: center;line-height: 100px;">暂无收据模板</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import InputSearch from '../../../components/Input/InputSearch'
  import TableMain from '../../../components/Table/TableMain'
  import {api} from '../../api/invoice'
  import {errorHandler} from '../../../utils/errorHandler'
  import ButtonConfirmNext from '../../../components/Button/ButtonConfirmNext'
  import {nAlert, nError, nSuccess} from '../../../utils/notice'
  import ButtonCancel from '../../../components/Button/ButtonCancel'
  import {capitalAmount} from "../../../tool/tools";
  import * as Printjs from "print-js";
  import bus from "../../../utils/bus";
  import ButtonConfirm from "../../../components/Button/ButtonConfirm";

  export default {
    components: {
      ButtonConfirm,
      ButtonCancel,
      ButtonConfirmNext,
      TableMain,
      InputSearch,
      Breadcrumb},
    name: 'invoice-receipt-collection-record',
    data () {
      return {
        permissionCodes: '',
        breadcrumb: [{
          value: '智慧凭证',
          name: 'invoice-over-view'
        }, {
          value: '收据管理'
        }],
        pickerOptions: {
          shortcuts: [{
            text: '未来一年',
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 365);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '未来三年',
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 365 * 3);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '未来十年',
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 365 * 10);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        pickerOptions2: {
          disabledDate (time) {
            return time.getTime() > new Date(((new Date) / 1000 + 86400) * 1000)
          },
          shortcuts: [{
            text: '最近一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近三个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }]
        },
        tableHead: [
          {prop: 'receiptNo', label: '收据单号'},
          {prop: 'openTypeText', label: '开具类型'},
          {prop: 'payer', label: '开票对象'},
          {prop: 'expenseItem', label: '费用项',},
          {prop: 'money', label: '金额(元)',},
          {prop: 'payTime', label: '收款时间',},
          {prop: 'issuer', label: '开票人',},
          {prop: 'createTime', label: '开票时间',}
        ],
        tableData: [],
        operationArr: ['reprint'],
        total: 0,
        pageSize: 10,
        pageNum: 1,
        timeValue: [],
        requestData: {
          pageNum: 1,
          pageSize: 10,
          startTime: '',
          endTime: '',
          searchKey: ''
        },
        selectionArr: [],

        makeInvoiceDialogVisible: false,
        payerList: [],
        payerCode: '',
        payer: '',
        enterpriseCode: '',
        personCode: '',
        payItemDetailCode: '',
        payItemDetailList: [],
        openTypeList: [
          {key: '1', label: '收据套打'},
          {key: '2', label: '模板打印'},
        ],
        openType: '1',
        receiptTemplate: '',
        issuer: '',
        payee: '',
        isDefault: false,

        receiptYear: '',
        receiptMonth: '',
        receiptDate: '',
        issueReceiptData: {},
        issueReceiptDialogVisible: false,

        makeInvoiceReprintDialogVisible: false,
        makeInvoiceReprintData: {},
        issueReceiptReprintDialogVisible: false,

        makeInvoiceByMainstayDialogVisible: false,
        enterpriseList: [],
        enterpriseCodeByMainstay: '',
        enterpriseNameByMainstay: '',
        paymentItemList: [],
        expenseCodeByMainstay: '',
        expenseNameByMainstay: '',
        chargingTime: [],
        startTime: '',
        endTime: '',
        totalAmount: '',
        payeeByMainstay: '',
        issuerByMainstay: '',
        issueByMainstayReceiptData: {},
        issueByMainstayReceiptDialogVisible: false,
        receiptTemplateDialogFormVisible: false,
        receiptTemplateDialogFormVisible2: false,
        downloadNoticeLoading: false,
        receiptTemplateDialogList: [],
        printingTemplateUrl: '',
        receiptTemplateDialogNum: '',
        newTemplateDialogData: {},
        receiptNo: ''
      }
    },
    created () {
      this.permissionCodes = bus.global.permissionCodes
      this.getCreatTime()
    },
    mounted() {},
    methods: {
      getTemplateList() {
        this.$axios.post(api.getReceiptTemplateList, {
          templateType: '2'
        })
          .then(res => {
            if (res.data.retCode === 1) {
              this.receiptTemplateDialogList = res.data.data;
            }
          })
          .catch(errorHandler('获取套打模板失败'))
      },
      getPrintingTemplate() {
        this.$axios.post(api.getReceiptTemplateList, {
          templateType: '1'
        })
          .then(res => {
            if (res.data.retCode === 1) {
              this.printingTemplateUrl = res.data.data[0] ? `url(${res.data.data[0].path})` : '';
            }
          })
          .catch(errorHandler('获取套打模板失败'))
      },
      // 收据单预览
      previewContract(path, fileName, code) {
        let formData = {};
        formData.templateCode = code;
        // console.log(this.issueReceiptData.payer, this.issueReceiptData, this.enterpriseCode, 'addddddddddddd')
        switch (this.receiptTemplateDialogNum) {
          case "1":
            formData.payer = this.issueReceiptData.payer;
            formData.billNo = this.issueReceiptData.billNo;
            formData.enterpriseCode = this.issueReceiptData.enterpriseCode;
            formData.expenseItem = this.issueReceiptData.itemName;
            formData.payee = this.issueReceiptData.payee;
            formData.issuer = this.issueReceiptData.issuer;
            break;
          case "2":
            formData.payer = this.makeInvoiceReprintData.payer;
            formData.billNo = this.makeInvoiceReprintData.payItemDetailCode;
            formData.payee = this.makeInvoiceReprintData.payee;
            formData.issuer = this.makeInvoiceReprintData.issuer;
            // formData.enterpriseCode = this.makeInvoiceReprintData.payer;
            break;
          case "3":
            // console.log(this.issueByMainstayReceiptData, 'this.issueByMainstayReceiptData')
            formData.payer = this.issueByMainstayReceiptData.enterpriseName;
            formData.paymentItemCode = this.issueByMainstayReceiptData.expenseCode;
            formData.expenseItem = this.issueByMainstayReceiptData.expenseItem;
            formData.enterpriseCode = this.issueByMainstayReceiptData.enterpriseCode;
            formData.startTime = this.issueByMainstayReceiptData.startTime;
            formData.endTime = this.issueByMainstayReceiptData.endTime;
            formData.money = this.issueByMainstayReceiptData.totalAmount;
            formData.payee = this.issueByMainstayReceiptData.payee;
            formData.issuer = this.issueByMainstayReceiptData.issuer;
            break;
        }
        this.downloadNoticeLoading = true
        this.$axios.post(api.createReceiptTemplate, formData)
          .then(res => {
            this.downloadNoticeLoading = false
            if (res.data.retCode === 1) {
              let data = res.data.data.receiptFileUrl;
              if (data) {
                window.open('http://view.officeapps.live.com/op/view.aspx?src=' + data, '_blank')
              } else {
                nError('预览失败')
              }
            }
          })
          .catch(errorHandler('预览失败'))
          .then(() => {
            this.downloadNoticeLoading = false
          })
      },
      // 收据单生成并下载
      downloadContract(path, fileName, code) {
        let formData = {};
        formData.templateCode = code;
        switch (this.receiptTemplateDialogNum) {
          case "1":
            formData.payer = this.issueReceiptData.payer;
            formData.billNo = this.issueReceiptData.billNo;
            formData.enterpriseCode = this.issueReceiptData.enterpriseCode;
            formData.expenseItem = this.issueReceiptData.itemName;
            formData.payee = this.issueReceiptData.payee;
            formData.issuer = this.issueReceiptData.issuer;
            break;
          case "2":
            formData.payer = this.makeInvoiceReprintData.payer;
            formData.billNo = this.makeInvoiceReprintData.payItemDetailCode;
            formData.enterpriseCode = this.makeInvoiceReprintData.payer;
            formData.payee = this.makeInvoiceReprintData.payee;
            formData.issuer = this.makeInvoiceReprintData.issuer;
            break;
          case "3":
            // console.log(this.issueByMainstayReceiptData, 'this.issueByMainstayReceiptData')
            formData.payer = this.issueByMainstayReceiptData.enterpriseName;
            formData.paymentItemCode = this.issueByMainstayReceiptData.expenseCode;
            formData.expenseItem = this.issueByMainstayReceiptData.expenseItem;
            formData.enterpriseCode = this.issueByMainstayReceiptData.enterpriseCode;
            formData.startTime = this.issueByMainstayReceiptData.startTime;
            formData.endTime = this.issueByMainstayReceiptData.endTime;
            formData.money = this.issueByMainstayReceiptData.totalAmount;
            formData.payee = this.issueByMainstayReceiptData.payee;
            formData.issuer = this.issueByMainstayReceiptData.issuer;
            break;
        }
        // console.log(formData, 'formData');
        this.downloadNoticeLoading = true
        this.$axios.post(api.createReceiptTemplate, formData)
          .then(res => {
            this.downloadNoticeLoading = false
            if (res.data.retCode === 1) {
              let data = res.data.data.receiptFileUrl;
              this.receiptNo = res.data.data.receiptNo || '';
              if (data) {
                switch (this.receiptTemplateDialogNum) {
                  case "1":
                    this.printDepositBillReceipt();
                    break;
                  case "2":
                    break;
                  case "3":
                    this.collectReceiptReceiptRecord();
                    break;
                }
                window.open(data, '_blank')
              } else {
                nError('地址无效')
              }
            }
          })
          .catch(errorHandler('生成失败'))
          .then(() => {
            this.receiptTemplateDialogFormVisible = false
            this.downloadNoticeLoading = false
          })
      },

      // 收据单预览
      previewContract2(path, fileName, code) {
        let formData = {};
        formData.templateCode = code;
        let {payer, billNo, expenseItem, enterpriseCode, paymentItemCode, startTime, endTime, expenseCode, money, payee, issuer} = this.newTemplateDialogData;
        formData.payer = payer || '';
        formData.billNo = billNo || '';
        formData.expenseItem = expenseItem || '';
        formData.enterpriseCode = enterpriseCode || '';
        formData.paymentItemCode = expenseCode || '';
        formData.expenseCode = expenseCode || '';
        formData.startTime = startTime || '';
        formData.endTime = endTime || '';
        formData.money = money || '';
        formData.payee = payee;
        formData.issuer = issuer;
        // console.log( this.newTemplateDialogData,formData, 'formData');
        this.downloadNoticeLoading = true
        this.$axios.post(api.createReceiptTemplate, formData)
          .then(res => {
            this.downloadNoticeLoading = false
            if (res.data.retCode === 1) {
              let data = res.data.data.receiptFileUrl;
              if (data) {
                window.open('http://view.officeapps.live.com/op/view.aspx?src=' + data, '_blank')
              } else {
                nError('预览失败')
              }
            }
          })
          .catch(errorHandler('预览失败'))
          .then(() => {
            this.downloadNoticeLoading = false
          })
      },

      // 收据单生成并下载
      downloadContract2(path, fileName, code) {
        let formData = {};
        formData.templateCode = code;
        let {payer, billNo, expenseItem, enterpriseCode, paymentItemCode, startTime, endTime, expenseCode, money, payee, issuer} = this.newTemplateDialogData;
        formData.payer = payer || '';
        formData.billNo = billNo || '';
        formData.expenseItem = expenseItem || '';
        formData.enterpriseCode = enterpriseCode || '';
        formData.paymentItemCode = expenseCode || '';
        formData.expenseCode = expenseCode || '';
        formData.startTime = startTime || '';
        formData.endTime = endTime || '';
        formData.money = money || '';
        formData.payee = payee;
        formData.issuer = issuer;
        // console.log( this.newTemplateDialogData,formData, 'formData');
        this.downloadNoticeLoading = true
        this.$axios.post(api.createReceiptTemplate, formData)
          .then(res => {
            this.downloadNoticeLoading = false
            if (res.data.retCode === 1) {
              let data = res.data.data.receiptFileUrl;
              this.receiptNo = res.data.data.receiptNo || '';
              if (data) {
                switch (this.receiptTemplateDialogNum) {
                  case "1":
                    this.printDepositBillReceipt();
                    break;
                  case "2":
                    break;
                  case "3":
                    this.collectReceiptReceiptRecord();
                    break;
                }
                window.open(data, '_blank')
              } else {
                nError('地址无效')
              }
            }
          })
          .catch(errorHandler('生成失败'))
          .then(() => {
            this.receiptTemplateDialogFormVisible2 = false
            this.downloadNoticeLoading = false
          })
      },

      // 查询开票对象
      getMainBodyList () {
        this.$axios.post(api.getMainBodyList, {
          voucherType: '收据',
          status: '1'
        })
          .then(res => {
            let data = res.data.data
            data.map(v => {
              if (v.enterpriseCode) {
                v._value = `${v.enterpriseCode}${v.payer}`
              } else {
                v._value = `${v.personCode}${v.payer}`
              }
            })
            this.payerList = data
          })
          .catch(errorHandler('查询开票对象失败'))
      },

      // 根据开票对象查询账单
      getReciptListByMainBody () {
        this.$axios.post(`${api.getReciptListByMainBody}`, {
          enterpriseCode: this.enterpriseCode,
          personCode: this.personCode
        })
          .then(res => {
            let data = res.data.data
            data.map(v => {
              v._label = `${v.itemName}/${v.money}元`
            })
            this.payItemDetailList = data
          })
          .catch(errorHandler('查询账单失败'))
      },

      // 查询默认开票人
      getIssuer () {
        this.$axios.get(`${api.getIssuer}`, {})
          .then(res => {
            let data = res.data.data
            if (data.issuer) {
              this.issuer = data.issuer
              this.issuerByMainstay = data.issuer
              this.isDefault = true
            }
          })
          .catch(errorHandler('查询默认开票人失败'))
      },


      toInvoiceRecordInfoPage (serialNo) {
        this.$router.push({
          path: `/invoice_info_current/${serialNo}`
        })
      },
      getCreatTime () {
        let nowDate = new Date
        let year = nowDate.getFullYear()
        let month = (nowDate.getMonth() + 1) < 10 ? '0' + (nowDate.getMonth() + 1) : (nowDate.getMonth() + 1)
        let date = nowDate.getDate() < 10 ? '0' + nowDate.getDate() : nowDate.getDate()
        // let hour = nowDate.getHours() < 10 ? '0' + nowDate.getHours() : nowDate.getHours()
        // let minute = nowDate.getMinutes() < 10 ? '0' + nowDate.getMinutes() : nowDate.getMinutes()
        // let second = nowDate.getSeconds() < 10 ? '0' + nowDate.getSeconds() : nowDate.getSeconds()
        this.receiptYear = year
        this.receiptMonth = month
        this.receiptDate = date
        this.timeValue[0] = year + '-' + month + '-01'
        this.timeValue[1] = year + '-' + month + '-' + date
        this.getPage()
      },
      changeTimeValue () {
        this.pageNum = 1
        this.pageSize = 10
        this.getPage()
      },
      getPage () {
        let reqData = this.requestData
        reqData.pageNum = this.pageNum
        reqData.pageSize = this.pageSize
        if (this.timeValue) {
          reqData.startTime = `${this.timeValue[0]} 00:00:00`
          reqData.endTime = `${this.timeValue[1]} 23:59:59`
        } else {
          reqData.startTime = ''
          reqData.endTime = ''
        }
        this.$axios.post(api.getReceiptRecordPage, reqData)
          .then(res => {
            let list = res.data.data.list
            this.total = res.data.data.total
            list.map((v, i) => {
              v.code = v.receiptNo ? v.receiptNo + i : i;
              if (v.invoiceStatus === 'SUCCESS') {
                v.invoiceStatusText = '开票成功'
              } else if (v.invoiceStatus === 'FAIL') {
                v.invoiceStatusText = '开票失败'
              } else if (v.invoiceStatus === 'PENDING') {
                v.invoiceStatusText = '开票中'
              } else if (v.invoiceStatus === 'INVALID') {
                v.invoiceStatusText = '已作废'
              }
              if (v.createTime) {
                v.createTime = v.createTime.slice(0, 19)
              }
              switch (v.openType) {
                case '1':
                  v.openTypeText = '收据套打';
                  break;
                case '2':
                  v.openTypeText = '模版打印';
                  break;
                default:
                  v.openTypeText = '';
                  break;
              }
            })
            this.tableData = list
          })
          .catch(errorHandler('获取失败'))
      },
      searchKey (v) {
        this.pageNum = 1
        this.requestData.searchKey = v
        this.getPage()
      },
      changePagination (data) {
        this.pageNum = data[0]
        this.pageSize = data[1]
        this.getPage()
      },

      changeWindowLeftPagination (data) {
        this.windowLeftPageNum = data[0]
        this.windowLeftPageSize = data[1]
        this.getPageApply()
      },

      changeSelection (codeArr) {
        this.selectionArr = codeArr
      },

      // 收据打印选择账单
      showMakeInvoiceDialogVisible () {
        this.makeInvoiceDialogVisible = true
        this.openType = '1';
        this.getMainBodyList()
        this.getIssuer()
      },

      // 重新打印
      reprintRow (data) {
        for (let i in data) {
          if (data[i] === '--') {
            data[i] = ''
          }
        }
        this.makeInvoiceReprintData = data
        this.makeInvoiceReprintData.openType = this.makeInvoiceReprintData.openType || '1'
        this.makeInvoiceReprintData.amountInWords = capitalAmount(this.makeInvoiceReprintData.money)
        this.makeInvoiceReprintData.amountUnit = `￥${parseInt(this.makeInvoiceReprintData.money  * 100)}`
        this.newTemplateDialogData = JSON.parse(JSON.stringify(this.makeInvoiceReprintData));
        this.makeInvoiceReprintDialogVisible = true
      },

      // 重新打印预览
      showIssueReceiptReprintDialog () {
        if (!this.makeInvoiceReprintData.issuer) {
          nError('请输入开票人')
          return false
        }
        // if (!this.openType) {
        //   nError('请选择开具类型')
        //   return false
        // }
        if (this.makeInvoiceReprintData.openType === '1') {
          this.makeInvoiceReprintDialogVisible = false
          this.issueReceiptReprintDialogVisible = true
        } else {
          this.makeInvoiceReprintDialogVisible = false;
          this.receiptTemplateDialogFormVisible2 = true;
          this.receiptTemplateDialogNum = '2';
        }
      },

      // 提交收据
      showIssueReceiptDialog () {
        if (!this.payItemDetailCode) {
          nError('请选择关联账单')
          return false
        }
        if (!this.issuer) {
          nError('请输入开票人')
          return false
        }
        if (!this.openType) {
          nError('请选择开具类型')
          return false
        }
        this.makeInvoiceDialogVisible = false
        this.payItemDetailList.map(v => {
          if (v.billNo === this.payItemDetailCode) {
            this.issueReceiptData = v
          }
        })
        this.issueReceiptData.issuer = this.issuer
        this.issueReceiptData.payee = this.payee
        this.issueReceiptData.payer = this.payer
        this.issueReceiptData.openType = this.openType
        this.issueReceiptData.enterpriseCode = this.enterpriseCode
        this.issueReceiptData.amountInWords = capitalAmount(this.issueReceiptData.money)
        this.issueReceiptData.amountUnit = `￥${parseInt(this.issueReceiptData.money  * 100)}`
        if (this.openType === '1') {
          this.issueReceiptDialogVisible = true
        } else {
          this.receiptTemplateDialogFormVisible = true;
          this.receiptTemplateDialogNum = '1';
        }
      },

      printReceipt () {
        Printjs({
          printable: "printReceipt", //要打印内容的id
          type: "html",
          style: '@page{size:auto;margin: -0.5cm 5.2cm 0cm -2cm;}',
          targetStyles: ['*']
        })
        setTimeout(() => {
          this.issueReceiptDialogVisible = false
          this.$confirm('系统检测到您有预打印操作，是否已打印此收据？此操作会更改记录状态，请谨慎操作。', "温馨提示", {
            type: "warning",
            closeOnClickModal: false
          })
            .then(() => {
              this.printDepositBillReceipt()
            })
            .catch(() => {});
        }, 200)
        // this.$print(this.$refs.print)
      },

      // 修改收据状态
      printDepositBillReceipt () {
        let issueReceiptData = this.issueReceiptData
        for (let i in issueReceiptData) {
          if (issueReceiptData[i] === '') {
            issueReceiptData[i] = null
          }
        }
        // console.log(this.issueReceiptData, 'issueReceiptData')
        issueReceiptData.isDefault = this.isDefault
        issueReceiptData.expenseItem = issueReceiptData.itemName
        issueReceiptData.receiptNo	 = this.receiptNo;
        this.$axios.post(api.printDepositBillReceipt, issueReceiptData)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('操作成功')
              this.getPage()
            }
          })
          .catch(errorHandler('操作失败'))
      },

      // 重新打印
      reprintReceipt () {
        Printjs({
          printable: "reprintReceipt", //要打印内容的id
          type: "html",
          style: '@page{size:auto;margin: -0.5cm 5.2cm 0cm -2cm;}',
          targetStyles: ['*']
        })
        setTimeout(() => {
          this.issueReceiptReprintDialogVisible = false
          this.makeInvoiceReprintDialogVisible = false
        }, 200)
      },



      showMakeInvoiceByMainstayDialogVisible () {
        this.enterpriseCodeByMainstay = '';
        this.chargingTime = [];
        this.expenseCodeByMainstay = '';
        this.totalAmount = '';
        this.payeeByMainstay = '';
        this.makeInvoiceByMainstayDialogVisible = true
        this.openType = '1';
        this.getEnterpriseList()
        this.getPaymentItemList()
        this.getIssuer()
      },
      // 查询主体列表
      getEnterpriseList () {
        this.$axios.post(api.getEnterpriseList, {})
          .then(res => {
            this.enterpriseList = res.data.data
          })
          .catch(errorHandler('查询主体失败'))
      },
      // 查询收费项列表
      getPaymentItemList () {
        this.$axios.post(api.getPaymentItemList, {
          type: '收据'
        })
          .then(res => {
            this.paymentItemList = res.data.data
          })
          .catch(errorHandler('查询收费项失败'))
      },
      // 计算汇总金额
      calculateTotalAmount () {
        if (!this.enterpriseCodeByMainstay || !this.expenseCodeByMainstay || !this.startTime || !this.endTime) {
          return false
        }
        this.$axios.post(api.calculateTotalAmount, {
          enterpriseCode: this.enterpriseCodeByMainstay,
          startTime: this.startTime,
          endTime: this.endTime,
          paymentItemCode: this.expenseCodeByMainstay,
        })
          .then(res => {
            this.totalAmount = res.data.data
          })
          .catch(errorHandler('计算汇总金额失败'))
      },
      // 汇总开票
      showIssueReceiptByMainstayDialog () {
        if (!this.enterpriseCodeByMainstay) {
          nError('请选择开票对象')
          return false
        }
        if (!this.startTime || !this.endTime) {
          nError('请选择收费时间')
          return false
        }
        if (!this.expenseCodeByMainstay) {
          nError('请选择收费项')
          return false
        }
        if (!this.totalAmount || this.totalAmount == 0) {
          nError('此金额无需开收据')
          return false
        }
        if (!this.issuerByMainstay) {
          nError('请输入开票人')
          return false
        }
        if (!this.openType) {
          nError('请选择开具类型')
          return false
        }
        this.makeInvoiceByMainstayDialogVisible = false
        this.issueByMainstayReceiptData.paymentItemCode = this.expenseCodeByMainstay;
        this.issueByMainstayReceiptData.payer = this.enterpriseNameByMainstay
        this.issueByMainstayReceiptData.enterpriseCode = this.enterpriseCodeByMainstay
        this.issueByMainstayReceiptData.enterpriseName = this.enterpriseNameByMainstay
        this.issueByMainstayReceiptData.expenseCode = this.expenseCodeByMainstay
        this.issueByMainstayReceiptData.expenseItem = this.expenseNameByMainstay
        this.issueByMainstayReceiptData.startTime = this.startTime
        this.issueByMainstayReceiptData.endTime = this.endTime
        this.issueByMainstayReceiptData.openType = this.openType
        this.issueByMainstayReceiptData.totalAmount = this.totalAmount
        this.issueByMainstayReceiptData.payee = this.payeeByMainstay
        this.issueByMainstayReceiptData.issuer = this.issuerByMainstay
        this.issueByMainstayReceiptData.amountInWords = capitalAmount(this.issueByMainstayReceiptData.totalAmount)
        this.issueByMainstayReceiptData.amountUnit = `￥${parseInt(this.issueByMainstayReceiptData.totalAmount  * 100)}`
        if (this.openType === '1') {
          this.issueByMainstayReceiptDialogVisible = true
        } else {
          this.receiptTemplateDialogFormVisible = true;
          this.receiptTemplateDialogNum = '3';
        }
      },

      printReceiptByMainstay () {
        Printjs({
          printable: "printReceiptByMainstay", //要打印内容的id
          type: "html",
          style: '@page{size:auto;margin: -0.5cm 5.2cm 0cm -2cm;}',
          targetStyles: ['*']
        })
        setTimeout(() => {
          this.issueByMainstayReceiptDialogVisible = false
          this.$confirm('系统检测到您有预打印操作，是否已打印此收据？此操作会更改记录状态，请谨慎操作。', "温馨提示", {
            type: "warning",
            closeOnClickModal: false
          })
            .then(() => {
              this.collectReceiptReceiptRecord()
            })
            .catch(() => {});
        }, 200)
      },
      // 修改收据状态
      collectReceiptReceiptRecord () {
        let issueReceiptData = this.issueByMainstayReceiptData
        for (let i in issueReceiptData) {
          if (issueReceiptData[i] === '') {
            issueReceiptData[i] = null
          }
        }
        issueReceiptData.isDefault = this.isDefault
        issueReceiptData.receiptNo	 = this.receiptNo;
        this.$axios.post(api.collectReceiptReceiptRecord, issueReceiptData)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('操作成功')
              this.getPage()
            }
          })
          .catch(errorHandler('操作失败'))
      },
    },
    watch: {
      timeValue (val) {
        this.getPage()
      },
      payerCode (val) {
        if (this.payerCode) {
          this.payerList.map(v => {
            if (v._value === val) {
              this.payer = v.payer
              this.enterpriseCode = v.enterpriseCode
              this.personCode = v.personCode
            }
          })
          this.payItemDetailCode = ''
          this.getReciptListByMainBody()
        }
      },
      makeInvoiceDialogVisible () {
        if (!this.makeInvoiceDialogVisible) {
          this.payerCode = ''
          this.payer = ''
          this.payItemDetailCode = ''
          this.issuer = ''
          this.payee = ''
        }
      },
      makeInvoiceReprintDialogVisible () {
        if (!this.makeInvoiceReprintDialogVisible) {
          this.getPage()
        }
      },

      enterpriseCodeByMainstay () {
        this.enterpriseList.map(v => {
          if (v.enterpriseCode === this.enterpriseCodeByMainstay) {
            this.enterpriseNameByMainstay = v.enterpriseName
            this.calculateTotalAmount()
          }
        })
      },
      expenseCodeByMainstay () {
        this.paymentItemList.map(v => {
          if (v.code === this.expenseCodeByMainstay) {
            this.expenseNameByMainstay = v.name
            this.calculateTotalAmount()
          }
        })
      },

      chargingTime () {
        if (this.chargingTime) {
          this.startTime = this.chargingTime[0]
          this.endTime = this.chargingTime[1]
          this.calculateTotalAmount()
        }
      },
    }
  }
</script>

<style scoped>
  .search-line {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
  .btn-box {
    display: flex;
    justify-content: flex-start;
  }
</style>

<style lang="less">
  .invoice-receipt-collection-record {
    .el-dialog .el-dialog__body .el-table .has-gutter th:first-child {
      /*width: 50%!important;*/
    }

    .right-slide-enter,
    .right-slide-leave-active {
      transform: translateX(100%);
    }

    .right-slide-leave-active,
    .right-slide-enter-active {
      transition: all 0.3s;
    }
    .window-left-box {
      position: fixed;
      right: 0;
      top: 0;
      bottom: 0;
      width: 60%;
      z-index: 10;
    }
    .window-left-box .move-enter-active, .window-left-box .move-leave-active {
      transition: all 2s linear;
      transform: translate3d(0, 0, 0);
    }
    .window-left-box .move-enter, .window-left-box .move-leave {
      transform: translate3d(100%, 0, 0);
    }
    .window-left-main {
      width: 100%;
      height: 100%;
      z-index: 30;
      background: #FFFFFF;
      padding: 5px 10px;
      overflow: auto;
    }

    .mask {
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      opacity: .4;
      z-index: -1;
      background-color: #000000;
      transition: opacity .5s ease;
    }

    form {
      width: 650px;
      margin: 0 auto;
      text-align: left;
    }
    .form-line {
      margin: 25px 0;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    .line-text{
      color: #48576a;
      font-size: 14px;
      margin-right: 10px;
      width: 100px;
      display: flex;
      justify-content: space-between;
    }
    .line-info {
      width: 220px;
    }
    .form-btn-box {
      width: 530px;
      padding: 0 124px;
      margin: 40px auto 0;
      display: flex;
      justify-content: space-between;
    }

    .person-management-drawer {
      .el-icon-back {
        margin: 20px 20px 10px;
        display: block;
        border: 0;
        font-size: 20px;
        background-color: #ffffff;
        cursor: pointer;
      }
      .el-icon-back:hover {
        color: #00a0e6;
      }
      .all-table-class .el-table td {
        padding: 10px 0;
      }
      form {
        position: relative;
        .drawerPersonImg {
          position: absolute;
          right: 0;
          top: 0;
          width: 120px;
        }
        .noDrawerPersonImg {
          position: absolute;
          right: 0;
          top: 0;
          width: 120px;
          height: 150px;
          line-height: 160px;
          border: 1px dashed #dcdfe6;
          text-align: center;
          color: #999999;
        }
      }
    }
    .drawerBtnBox {
      width: 360px;
      padding-right: 60px;
      margin: 40px auto 0;
      .btn-confirm {
        border: 0;
        color: #FFF;
        padding: 8px 16px;
        background-color: #00a0e6;
        border-radius: 4px;
        margin-right: 60px;
      }
      .btn-confirm:hover {
        color: #FFF;
        background-color: #06b3ff;
      }
      .reject-button {
        border: 0;
        background-color: #f25721;
        color: #FFFFFF;
        border-radius: 4px;
      }
      .reject-button:hover {
        background-color: #F96E3D;
      }
    }

    .receipt-box {
      width: 642.52px;
      height: 305px;
      margin: 0 auto;
      background: url("../../../assets/receipt.jpg") no-repeat;
      background-size: 100% 100%;
      position: relative;
      .printing-box {
        width: 642.52px;
        height: 305px;
        color: #111111;
        position: relative;
        top: 0;
        left: 0;
        font-size: 12px;
        .printing-info1 {
          width: 80px;
          text-align: left;
          position: absolute;
          top: 65px;
          left: 140px;
        }
        .printing-info2 {
          display: flex;
          justify-content: space-between;
          align-items: center;
          position: absolute;
          top: 65px;
          right: 65px;
          .printing-info2-1 {
            width: 40px;
            margin-right: 10px;
          }
          .printing-info2-2 {
            width: 40px;
            margin-right: 10px;
          }
          .printing-info2-3 {
            width: 40px;
          }
        }
        .printing-info3 {
          text-align: left;
          width: 240px;
          height: 45px;
          padding-left: 10px;
          position: absolute;
          top: 84px;
          left: 135px;
          display: flex;
          justify-content: center;
          flex-direction: column;
        }
        .printing-info4 {
          text-align: left;
          width: 140px;
          height: 45px;
          position: absolute;
          top: 84px;
          right: 36px;
          display: flex;
          justify-content: center;
          flex-direction: column;
        }
        .printing-info5 {
          text-align: left;
          padding-left: 10px;
          width: 260px;
          height: 40px;
          line-height: 40px;
          position: absolute;
          top: 134px;
          left: 185px;
        }
        .printing-info6 {
          text-align: left;
          width: 160px;
          height: 36px;
          position: absolute;
          top: 148px;
          right: 36px;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          .printing-info6-item {
            width: 16.5px;
            height: 36px;
            line-height: 36px;
            font-size: 20px;
            text-align: center;
            font-style: italic;
            font-weight: bolder;
          }
        }
        .printing-info7 {
          text-align: left;
          width: 100px;
          height: 30px;
          line-height: 15px;
          position: absolute;
          bottom: 2px;
          right: 30px;
        }
        .printing-info8 {
          text-align: left;
          width: 100px;
          height: 20px;
          position: absolute;
          bottom: 10px;
          right: 190px;
        }
      }
    }

    .el-dialog__body {
      .el-table .cell{
        text-align: center;
      }
      .el-table th>.cell {
        color: #48576a;
        font-weight: bold;
      }
    }
    .el-dialog {
      .el-dialog .el-dialog__body .el-table__empty-block {
        margin: 0 auto;
      }
      .el-table__empty-text {
        width: auto;
      }
      .el-dialog__header {
        text-align: center
      }
      .el-dialog__body {
        .el-table th:first-child {
          width: auto!important;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/Invoice/InvoiceReceiptManage/InvoiceReceiptCollectionRecord.vue